import script from "./SocialProcessPage.vue?vue&type=script&lang=ts"
export * from "./SocialProcessPage.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__